
define('text!plugins/templates/HSGraduatesToEmployment_hoursWages_head.html!strip',[],function () { return '{{#data.hoursAndWages}}\n\t\t <strong>{{organizations.0.orgName}}</strong>\n\t\t{{/data.hoursAndWages}}\n\t';});

